import React from "react";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { Link } from "react-router-dom";

const Otpverify = ({
  handleChangeOTP,
  email,
  handleOtpverify,
  otpValue,
  getVerifyLoading,
  handleResendOTP,
}) => {
  const handleSubmit = () => {
    if (otpValue.length === 6) {
      handleOtpverify();
    } else {
      alert("Please enter a complete OTP.");
    }
  };

  return (
    <div
      className="fixed inset-0 bg-foreground/60 flex justify-center items-center z-50 p-4 sm:p-6 font-sans"
    >
      <div className="bg-card p-5 sm:p-8 rounded-xl border border-border shadow-theme w-full max-w-lg text-center max-h-[calc(100dvh-2rem)] overflow-y-auto custom-scrollbar">
        <div className="h-1.5 card-gradient-strip -m-5 sm:-m-8 mb-4 sm:mb-5 rounded-t-xl" />
        <h2 className="font-heading text-xl font-bold text-primary tracking-tight mb-2">Verify OTP</h2>
        <div className="flex justify-center my-4">
          <span className="flex h-24 w-24 items-center justify-center rounded-xl bg-secondary">
            <MdOutlineMarkEmailRead size={56} className="text-primary" />
          </span>
        </div>
        <p className="text-sm text-muted-foreground">
          Please enter the 6 digit code sent to{" "}
          <span className="font-bold text-foreground">{email}</span>
        </p>
        <div className="mt-5 sm:mt-6">
          <div className="mb-4 text-start ">
            <label className="bef-label">OTP</label>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otpValue.otp}
              onChange={handleChangeOTP}
              maxLength="6"
              className="bef-input tracking-widest text-center font-mono"
              required
            />
          </div>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={getVerifyLoading}
            className={`bef-btn-primary w-full transition-all duration-300 ${
              getVerifyLoading
                ? "!bg-primary !border-primary !text-white opacity-90 cursor-wait pointer-events-none"
                : ""
            }`}
          >
            {getVerifyLoading ? <div className="loader"></div> : "Verify"}
          </button>
        </div>
        <p className="mt-4 text-sm text-muted-foreground">
          Didn&apos;t receive a code?{" "}
          <span
            onClick={handleResendOTP}
            className="text-primary font-bold underline cursor-pointer hover:text-accent transition-colors"
          >
            Resend
          </span>
        </p>
        <p className="mt-2 text-sm text-muted-foreground">
          Back to Login{" "}
          <Link to="/" className="text-primary font-bold underline hover:text-accent transition-colors">
            Click here
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Otpverify;
